import { GoalDraft } from '@app/models/goals/goal-draft.model';

export const mockGoalDrafts: GoalDraft[] = [

];